import { useState } from "react";
import defaultLogo from "../../../assets/logo.svg";

function Logo({ logoUrl, alt = "Logo", className, fallback = null, onError, ...imgProps }) {
  console.log("[Logo] Received logoUrl prop:", logoUrl);
  const [hasError, setHasError] = useState(false);

  const resolveLogoUrl = (value) => {
    if (!value || typeof value !== "string") return null;
    if (/^https?:\/\//i.test(value)) return value;

    const minioHost = process.env.REACT_APP_MINIO_PUBLIC_HOST || process.env.REACT_APP_MINIO_HOST || "minio";
    const minioPort = process.env.REACT_APP_MINIO_PUBLIC_PORT || process.env.REACT_APP_MINIO_PORT || "9000";
    const minioProtocol = process.env.REACT_APP_MINIO_PUBLIC_PROTOCOL || "http";
    const objectName = value.replace(/^\/+/, "");
    return `${minioProtocol}://${minioHost}:${minioPort}/public/${objectName}`;
  };

  const src = resolveLogoUrl(logoUrl);

  if (process.env.NODE_ENV === "development") {
    console.log("[TenantLogo] Resolved logo URL:", src);
  }

  if (!src || hasError) {
    if (fallback) return fallback;
    return <img {...imgProps} src={defaultLogo} alt={alt} className={className} />;
  }

  return (
    <img
      {...imgProps}
      src={src}
      alt={alt}
      className={className}
      onError={(event) => {
        setHasError(true);
        if (onError) onError(event);
      }}
    />
  );
}

export default Logo;
